const CopyrightInfo = () => (
    <>
        <div className="self-center mt-10 text-center mb-2">
            <p className="text-xs self-center">
                © 2025 AMCO Intermediários de Crédito, Lda. Todos os direitos reservados.
            </p>
        </div>
    </>
);

export default CopyrightInfo;